import React from 'react';
import { classNameBuilder } from '../../utils/className';

import './Container.scss';

interface IProps {
    type?: 'default' | 'old' | 'scrollBar';
    className?: string;
    children: React.ReactNode;
}

const Container: React.FC<IProps> = ({ children, type = 'old', className }) => {
    const cn = classNameBuilder('container');

    return <div className={`${cn({ type })} ${className ?? ''}`}>{children}</div>;
};

export default Container;
